import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { CrmTaskService } from '../../services/crm-task.service';
import { KundeKortService } from '../../services/kunde-kort.service';
import { KundekortInfoPopup } from '../kunde-kort/kunde-kort-popup/kunde-kort-info-popup';

@Component({
  selector: 'app-my-tasks',
  templateUrl: './my-tasks.component.html',
  styleUrls: ['./my-tasks.component.css']
})
export class MyTasksComponent implements OnInit, OnDestroy {
  tasks: any[] = [];
  loading = true;
  private tasksSub: Subscription;
  private userSub: Subscription;

  constructor(
    private auth: AuthService,
    private taskService: CrmTaskService,
    private kundeKortService: KundeKortService,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.userSub = this.auth.user$.subscribe(u => {
      if (this.tasksSub) this.tasksSub.unsubscribe();
      if (!u?.uid) { this.tasks = []; this.loading = false; return; }
      this.tasksSub = this.taskService.getOpenTasksForAssignee(u.uid).subscribe(list => {
        this.tasks = (list as any[]).sort((a, b) => this.toMillis(a.dueDate) - this.toMillis(b.dueDate));
        this.loading = false;
      });
    });
  }

  toMillis(value: any): number {
    if (!value) return 0;
    if (typeof value.toDate === 'function') return value.toDate().getTime();
    return new Date(value).getTime();
  }

  private startOfToday(): number {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d.getTime();
  }

  isOverdue(task: any): boolean {
    return this.toMillis(task.dueDate) < this.startOfToday();
  }

  isDueToday(task: any): boolean {
    const due = this.toMillis(task.dueDate);
    return due >= this.startOfToday() && due < this.startOfToday() + 86400000;
  }

  completeTask(task: any) {
    this.taskService.completeTask(task.dbid).catch(err => console.error('Error completing task', err));
  }

  async openCustomer(task: any) {
    if (!task.kundekortId) return;
    const doc = await this.kundeKortService.getCustomerById(task.kundekortId).toPromise();
    if (!doc || !doc.exists) return;
    this.dialog.open(KundekortInfoPopup, {
      width: '95vw',
      maxWidth: '1440px',
      height: '92vh',
      data: { ...(doc.data() as object), kundekortId: task.kundekortId },
    });
  }

  ngOnDestroy() {
    if (this.tasksSub) this.tasksSub.unsubscribe();
    if (this.userSub) this.userSub.unsubscribe();
  }
}
